import { FormTextSelect } from "@circle-react-shared/uikit/Form/FormTextSelect";
import { t } from "@/i18n-js/instance";
import { UPSELL_LOCALE_ROOT } from "../../constants";
import { TitleAndSubtitle } from "../components/TitleAndSubtitle";
import { useUpsellTabContext } from "../../UpsellTabContext";

export const PaywallSelectionForm = () => {
  const { paywallOptions, offeredPaywall } = useUpsellTabContext();

  if (offeredPaywall) {
    return null;
  }

  return (
    <>
      <TitleAndSubtitle
        title={t([UPSELL_LOCALE_ROOT, "forms.addon.title"])}
        subtitle={t([UPSELL_LOCALE_ROOT, "forms.addon.description"])}
      />
      <FormTextSelect
        name="paywall_offers_attributes.offered_paywall_id"
        rules={{ required: true }}
        hideLabel
        options={paywallOptions || []}
      />
    </>
  );
};
